import SimpleDate from 'app/common/classes/simple-date'
import { daysFormat } from 'app/common/api/requests/reports/data/_predefined/common/average-check/data.type'
import { extractDateFromColumnKey } from './create-column-keys'
import { Entity } from './types'

const headerCells: Record<string, string> = {
  [Entity.Title]: '',
  [Entity.Total]: 'Всего',
}

export const createHeaderCells = (outputDateFormat: string = 'DD.MM') => {
  return new Proxy(headerCells, {
    get: function (target, property) {
      const res = target[String(property)]
      if (!res) {
        const key = extractDateFromColumnKey(property as string)
        return new SimpleDate(key, daysFormat).getStringFormatted(outputDateFormat)
      }
      return res || ''
    },
  })
}
